import { apiClient } from "../client";

// =========================
// Stages
// =========================
export const listStages = async () => {
  const { data } = await apiClient.get("/enrollment/stages");
  return data || [];
};

export const createStage = async (stageData) => {
  const { data } = await apiClient.post("/enrollment/stages", stageData);
  return data;
};

export const updateStage = async (stageId, stageData) => {
  const { data } = await apiClient.put(`/enrollment/stages/${stageId}`, stageData);
  return data;
};

export const deleteStage = async (stageId) => {
  const { data } = await apiClient.delete(`/enrollment/stages/${stageId}`);
  return data;
};

export const reorderStages = async (stages) => {
  const { data } = await apiClient.post("/enrollment/stages/reorder", { stages });
  return data;
};

// =========================
// Segments
// =========================
export const listSegments = async () => {
  const { data } = await apiClient.get("/enrollment/segments");
  return data || [];
};

export const createSegment = async (segmentData) => {
  const { data } = await apiClient.post("/enrollment/segments", segmentData);
  return data;
};

export const updateSegment = async (segmentId, segmentData) => {
  const { data } = await apiClient.put(`/enrollment/segments/${segmentId}`, segmentData);
  return data;
};

export const deleteSegment = async (segmentId) => {
  const { data } = await apiClient.delete(`/enrollment/segments/${segmentId}`);
  return data;
};

// =========================
// Sources
// =========================
export const listSources = async () => {
  const { data } = await apiClient.get("/enrollment/sources");
  return data || [];
};

export const createSource = async (sourceData) => {
  const { data } = await apiClient.post("/enrollment/sources", sourceData);
  return data;
};

export const updateSource = async (sourceId, sourceData) => {
  const { data } = await apiClient.put(`/enrollment/sources/${sourceId}`, sourceData);
  return data;
};

export const deleteSource = async (sourceId) => {
  const { data } = await apiClient.delete(`/enrollment/sources/${sourceId}`);
  return data;
};

// =========================
// Leads
// =========================
export const listLeads = async () => {
  const { data } = await apiClient.get("/enrollment/leads");
  return data || [];
};

export const showLead = async (leadId) => {
  const { data } = await apiClient.get(`/enrollment/leads/${leadId}`);
  return data;
};

export const createLead = async (leadData) => {
  const { data } = await apiClient.post("/enrollment/leads", leadData);
  return data;
};

export const updateLead = async (leadId, leadData) => {
  const { data } = await apiClient.put(`/enrollment/leads/${leadId}`, leadData);
  return data;
};

export const deleteLead = async (leadId) => {
  const { data } = await apiClient.delete(`/enrollment/leads/${leadId}`);
  return data;
};

export const updateLeadStage = async (leadId, stageId) => {
  const { data } = await apiClient.put(`/enrollment/leads/${leadId}/stage`, { stageId });
  return data;
};

export const searchLeads = async (searchParams) => {
  const { data } = await apiClient.post("/enrollment/leads/search", searchParams);
  return data;
};

// =========================
// Activities
// =========================
export const listLeadActivities = async (leadId) => {
  const { data } = await apiClient.get(`/enrollment/leads/${leadId}/activities`);
  return data || [];
};

export const createLeadActivity = async (leadId, activityData) => {
  const { data } = await apiClient.post(`/enrollment/leads/${leadId}/activities`, activityData);
  return data;
};

export const updateLeadActivity = async (activityId, activityData) => {
  const { data } = await apiClient.put(`/enrollment/activities/${activityId}`, activityData);
  return data;
};

export const deleteLeadActivity = async (activityId) => {
  const { data } = await apiClient.delete(`/enrollment/activities/${activityId}`);
  return data;
};

export const completeLeadActivity = async (activityId, payload = {}) => {
  const { data } = await apiClient.put(`/enrollment/activities/${activityId}/complete`, payload);
  return data;
};

